import { useTranslations } from 'next-intl';

import Card from '@commons/components/Card';
import DrupalImage from '@commons/components/Image/Drupal';
import TopoPatternImage from '@commons/components/Image/TopoPattern';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import { useFormattedDate } from '@commons/hooks/useFormattedDate';
import { Link } from '@commons/i18n/navigation';
import { SMALL_CARD_DISPLAY_IMAGE_SIZES } from '@commons/pagebuilder/nodes/images';

import type { CaseStudyNodeProps } from '.';

/**
 * CaseStudy node component for the small card display type.
 */

const CaseStudyNodeSmallCard = (props: CaseStudyNodeProps) => {
  const t = useTranslations();

  const { image, title, date, alias, format } = props;

  const upperTitle = format ? format.name : t('nodes.caseStudy.label');

  const formattedDate = useFormattedDate(date);

  const renderedImage = image ? (
    <DrupalImage {...image} sizes={SMALL_CARD_DISPLAY_IMAGE_SIZES} />
  ) : (
    <TopoPatternImage alt={title} sizes={SMALL_CARD_DISPLAY_IMAGE_SIZES} />
  );

  return (
    <Link href={alias}>
      <Card gap="xs" justify="space-between">
        <Flex gap="xs" direction="column">
          <Card.Overlay>{renderedImage}</Card.Overlay>
          <Text as="h6" level="label-md" transform="uppercase" marginBottom="none">
            {upperTitle}
          </Text>
          <Card.Title>{title}</Card.Title>
        </Flex>
        <Text level="body-xs" transform="uppercase" marginBottom="none">
          {formattedDate}
        </Text>
      </Card>
    </Link>
  );
};

export default CaseStudyNodeSmallCard;
